
export const responseDefault = {
    rows: [],
    limit: 0,
    offset: 0,
    count: 0
}